var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('BookForm',{attrs:{"params":_vm.params,"result":_vm.result,"pack":_vm.pack,"category":_vm.category,"meal":_vm.meal},on:{"back":_vm.onBack,"book":_vm.onBook}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }